import { render, staticRenderFns } from "./UserFunds.vue?vue&type=template&id=377d6f13&scoped=true"
import script from "./UserFunds.vue?vue&type=script&lang=js"
export * from "./UserFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d6f13",
  null
  
)

export default component.exports